import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';

const useProfileOwner = profile => {
  const { currentUser, loggedIn } = useSelector(state => state.auth);
  const { pathname } = useRouter();

  if (!loggedIn) return false;

  if (!currentUser.full_management_agency) return currentUser.profile_ids?.includes(profile?.id);

  if (currentUser.currently_managing_profile) {
    // Agency is managing a specific profile - Consider all other (not selected) as not owned in order not to edit them
    return (
      currentUser.profile_ids?.includes(profile?.id) && currentUser?.profile_id === profile?.id
    );
  } else if (pathname === '/agency-discover') {
    // Agency is not managing a profile and is on the agency discover page - Consider all profiles as not owned in order to buy from them
    return false;
  }
};

export default useProfileOwner;
